import React from "react";
import get from "lodash/get";
import { object, string, number } from "yup";
import { Formik, Form } from "formik";
import { useQuery, useMutation } from "services/Client";
import { useParams, useNavigate } from "react-router-dom";
import { useNotification } from "hooks";

import CreateOrEditUnit from "../shared/CreateOrEditUnit";
export default function EditUnit() {
  const { id } = useParams();
  const notification = useNotification();

  let navigate = useNavigate();
  const { data } = useQuery({
    event: "unit.get.one",
    variables: {
      id,
    },
    skip: !id,
  });
  const unit = get(data, "unit_by_pk", {
    name: "",
    order: 0,
    passingScore: 0,
  });

  const { mutate: updateLevel } = useMutation({
    event: "unit.update",
    onCompleted: () => {
      notification.success({
        message: "Unit Saved",
      });
      navigate(-1);
    },
  });

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        name: unit.name,
        order: unit.order,
        passingScore: unit.passingScore
      }}
      onSubmit={(values) =>
        updateLevel({
          variables: {
            _set: {
              ...values,
            },
            pk_columns: { id },
          },
        })
      }
      validationSchema={object({
        name: string().min(5, "error").required("error"),
        order: number().required("error").positive().integer(),
        passingScore: number().required("error").positive().integer(),
      })}
    >
      <Form>
        <CreateOrEditUnit onCancel={() => navigate(-1)} />
      </Form>
    </Formik>
  );
}
